// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260904.1788538053/static/js/" + chunkId + "." + {"249":"a3b92553","463":"e80118b9"}[chunkId] + ".chunk.js";
};